import React from "react";
import "./AcceptModal.css";

const AcceptModal = ({ isOpen, onClose, onProceed }) => {

  if (!isOpen) return null;

  return (
    <div className="accept-modal-overlay">
      <div className="accept-modal-content">
        <button className="accept-close-button" onClick={onClose}>
          ×
        </button>
        <div className="accept-modal-body">
          <img
            src={"/images/successModal.png"}
            alt="Event"
            className="accept-modal-image"
          />
          <h2 className="accept-modal-title">We're Glad You're Coming!</h2>
          <p className="accept-modal-description">
            A huge thank you for saying yes to our invite! We're excited to have
            you with us. Find more information about the event by clicking the
            proceed button below.
          </p>
          <div className="accept-modal-buttons">
            <button className="accept-close-button-modal" onClick={onClose}>
              Close
            </button>
            <button className="accept-proceed-button" onClick={onProceed}>
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcceptModal;
